import React from "react";
import { IForm } from "../../../../types/form.type";
import { Grid2, Stack } from "@mui/material";
import TextInput from "../../input/TextInput";
import { Controller, useForm } from "react-hook-form";
import ModalForm from "../../modal/ModalForm";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import { useSelector } from "react-redux";
import NumberInput from "../../input/NumberInput";
import { numeralCustom } from "../../../../utils/helpers";
import DateInput from "../../input/DateInput";

function FormCRVTYT({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const token = useSelector((state: any) => state.auth.token);
  const defaultData = {
    id: "",
    ten_vtyt: "",
    dvt: "",
    soluong: 0,
    xuatxu: "",
    nhanhieu: "",
    kyhieu: "",
    hsx: "",
    mahs: "",
    model: "",
    soluuhanh: "",
    //
    namsx: "",
    cauhinhkythuat: "",
    dongia: 0,
    tbmt: "",
    cdt: "",
    ngay_kqlcnt: null,
    sqd: "",
    ngayqd: null,
    slnhathau: "",
    diadiem: "",
    ndqd: "",
  };
  const originData = !!defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
      }
    : defaultData;
  const {
    control,
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
  });

  const handleSave = async (values: typeof defaultData) => {
    try {
      if (isEdit) {
        await asyncPutData({
          id: defaultValues?._id,
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: values,
        });
      } else {
        await asyncPostData({
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: values,
        });
      }
      onClose();
      setLoad?.((prev: number) => prev + 1);
    } catch (error: any) {
      alert(error?.error || error?.message || "Lưu không thành công");
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="1000px"
      formTitle="thuốc"
      open={open}
      onClose={onClose}
      isEdit={isEdit}
      onSubmit={onSubmit}
      loading={isSubmitting}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <TextInput
              multiline
              label="ID (BV)"
              id="id"
              labelWidth="30%"
              placeholder="Nhập ID"
              name="id"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Tên thiết bị"
              id="ten_vtyt"
              labelWidth="30%"
              placeholder="Nhập tên thiết bị"
              name="ten_vtyt"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Đơn vị tính"
              labelWidth="30%"
              id="dvt"
              placeholder="Nhập đơn vị tính"
              name="dvt"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Khối lượng"
              labelWidth="30%"
              id="soluong"
              placeholder="Nhập khối lượng"
              name="soluong"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Xuất xứ"
              labelWidth="30%"
              id="xuatxu"
              placeholder="Nhập xuất xứ"
              name="xuatxu"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Nhãn hiệu"
              id="nhanhieu"
              labelWidth="30%"
              placeholder="Nhập nhãn hiệu"
              name="nhanhieu"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Ký mã hiệu"
              id="kyhieu"
              labelWidth="30%"
              placeholder="Nhập ký mã hiệu"
              name="kyhieu"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Hãng sản xuất"
              id="hsx"
              labelWidth="30%"
              placeholder="Nhập hãng sản xuất"
              name="hsx"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Mã hồ sơ"
              id="mahs"
              labelWidth="30%"
              placeholder="Nhập mã hồ sơ"
              name="mahs"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Chủng loại"
              id="model"
              labelWidth="30%"
              placeholder="Nhập chủng loại"
              name="model"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Số lưu hành"
              id="soluuhanh"
              labelWidth="30%"
              placeholder="Nhập Số lưu hành"
              name="soluuhanh"
              register={register}
            />
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <TextInput
              readOnly
              multiline
              label="Năm sản xuất"
              id="namsx"
              labelWidth="30%"
              placeholder="Nhập năm sản xuất"
              name="namsx"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Cấu hình kỹ thuật"
              id="cauhinhkythuat"
              labelWidth="30%"
              placeholder="Nhập cấu hình kỹ thuật"
              name="cauhinhkythuat"
              register={register}
            />
            <Controller
              control={control}
              name="dongia"
              render={({ field: { value, onChange } }) => {
                return (
                  <TextInput
                    readOnly
                    label="Đơn giá"
                    id="dongia"
                    labelWidth="30%"
                    placeholder="Nhập đơn giá"
                    value={numeralCustom(value).format()}
                    onChange={(e) => {
                      const val = numeralCustom(e.target.value).value();
                      onChange(val);
                    }}
                  />
                );
              }}
            />
            <TextInput
              readOnly
              multiline
              label="Mã TBMT"
              id="tbmt"
              labelWidth="30%"
              placeholder="Nhập mã TBMT"
              name="tbmt"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Tên CĐT"
              id="cdt"
              labelWidth="30%"
              placeholder="Nhập tên CĐT"
              name="cdt"
              register={register}
            />
            <Controller
              control={control}
              name="ngay_kqlcnt"
              render={({ field: { value, onChange } }) => {
                return (
                  <DateInput
                    readOnly
                    label="Ngày đăng tải KQLCNT"
                    labelWidth="30%"
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
            <TextInput
              readOnly
              multiline
              label="Số quyết định"
              id="soquyetdinh"
              labelWidth="30%"
              placeholder="Nhập số quyết định"
              name="soquyetdinh"
              register={register}
            />
            <Controller
              control={control}
              name="ngayquyetdinh"
              render={({ field: { value, onChange } }) => {
                return (
                  <DateInput
                    readOnly
                    label="Ngày quyết định"
                    labelWidth="30%"
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
            <TextInput
              multiline
              label="Nội dung quyết định"
              id="ndqd"
              labelWidth="30%"
              placeholder="Nhập nội dung quyết định"
              name="ndqd"
              register={register}
            />
            <NumberInput
              readOnly
              label="Số lượng nhà thầu"
              min={0}
              id="slnhathau"
              labelWidth="30%"
              placeholder="Nhập số lượng nhà thầu"
              name="slnhathau"
              register={register}
            />
            <TextInput
              readOnly
              multiline
              label="Địa điểm"
              id="diadiem"
              labelWidth="30%"
              placeholder="Nhập địa điểm"
              name="diadiem"
              register={register}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </ModalForm>
  );
}

export default FormCRVTYT;
